export const mutations = {
  STORE_JOBCARDS(state, jobcards) {
    state.jobcards = jobcards;
  },

  STORE_JOBCARD_UPDATE(state, jobcardId) {
    let Jobcard = state.jobcards.find(function(jobcards) {
      return jobcards.id === jobcardId;
    });
    state.systemJobcard = Jobcard;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/jobcards/mutations.js